import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const ReviewerAccessPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setErrorMsg('Falta el token de acceso.');
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API}/api/auth/reviewer-login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ token }),
        });
        if (!res.ok) {
          setStatus('error');
          setErrorMsg('Token invalido o expirado.');
          return;
        }
        setStatus('success');
        // Refresh the app so context picks up the new session
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 800);
      } catch (e) {
        setStatus('error');
        setErrorMsg('Error de conexion.');
      }
    })();
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 mystic-bg">
      <div className="glass-card p-8 max-w-md w-full text-center" data-testid="reviewer-access-card">
        <h1 className="text-2xl font-bold text-purple-300 mb-2">Acceso de revisor</h1>
        {status === 'loading' && (
          <>
            <Loader2 className="w-8 h-8 text-purple-400 animate-spin mx-auto my-6" />
            <p className="text-[var(--text-secondary)]">Iniciando sesion de prueba...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="text-4xl my-4">✓</div>
            <p className="text-green-400">Sesion iniciada. Redirigiendo...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="text-4xl my-4">✗</div>
            <p className="text-red-400">{errorMsg}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default ReviewerAccessPage;
